import { Component, inject, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaUpdateService } from '../../../services/pwa-update.service';

@Component({
  selector: 'app-pwa-update-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pwa-update-notification.html',
  styleUrls: ['./pwa-update-notification.scss']
})
export class PwaUpdateNotificationComponent {
  protected pwaUpdateService = inject(PwaUpdateService);

  constructor() {
    // Watch for update availability and play sound
    effect(() => {
      if (this.pwaUpdateService.updateAvailable()) {
        this.playNotificationSound();
      }
    });
  }

  private playNotificationSound(): void {
    // Create a pleasant notification sound using Web Audio API
    try {
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

      // Create oscillators for a pleasant "ding" sound
      const oscillator1 = audioContext.createOscillator();
      const oscillator2 = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      // Configure oscillators (pleasant bell-like tones)
      oscillator1.frequency.setValueAtTime(800, audioContext.currentTime); // E5
      oscillator2.frequency.setValueAtTime(1200, audioContext.currentTime); // E6
      oscillator1.type = 'sine';
      oscillator2.type = 'sine';

      // Configure gain (volume envelope)
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

      // Connect the audio nodes
      oscillator1.connect(gainNode);
      oscillator2.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Play the sound
      oscillator1.start(audioContext.currentTime);
      oscillator2.start(audioContext.currentTime);
      oscillator1.stop(audioContext.currentTime + 0.5);
      oscillator2.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.warn('Could not play notification sound:', error);
    }
  }

  onUpdateClick(): void {
    this.pwaUpdateService.activateUpdate();
  }

  onDismissClick(): void {
    this.pwaUpdateService.dismissUpdate();
  }
}
